// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2f8Bq","subheader":"ReorderModal_subheader__2BG_R","listWrap":"ReorderModal_listWrap__2OfFH"};